module.exports = "/_next/static/images/harajuku_lunch_bread-46f9b12b7b12174aa868db280eba7e0d.jpg";